import React from 'react';
// Components
import ManageDesigns from 'components/common/ManageDesigns';

const ManageContentCreatorDesigns = (): JSX.Element => {
  return <ManageDesigns />;
};

export default ManageContentCreatorDesigns;
